import IMG1 from "../assets/media_file_formats.jpg";
import IMG2 from "../assets/OIP.jpg";
import ANDREIPIC from "../assets/andreipic.jpeg";
import RINORPIC from "../assets/rinorpic.png";
import GREGORPIC from "../assets/gregorpic.png";
import MARVINPIC from "../assets/marvinpic.png";



export const articles = [
    {
        id: 1,
        image: IMG1,
        title: 'Media file formats',
        author: 'Gregor',
        subjects: [
            {
                subTitle: "MP3",
                subTextShort: "audio.mp3",
                subTextLong: "The MP3 format revolutionized the way we listen to music. Developed by the Moving Picture Experts Group, it was created to compress audio files without sacrificing much of the original quality. MP3 files significantly reduced file sizes while maintaining a reasonable level of sound fidelity, making it easy to store and share music online. The format's widespread adoption made it the de facto standard for digital audio, allowing music lovers to create vast digital music libraries and enjoy their favorite songs on various devices. "
            },
            {
                subTitle: "JPEG",
                subTextShort: "image.jpeg",
                subTextLong: "The JPEG format, short for Joint Photographic Experts Group, was designed to compress and store digital images efficiently. By utilizing lossy compression, JPEG files can achieve significant reductions in file size while maintaining acceptable image quality. This format is widely used in photography and digital imaging, allowing photographers and users to store and share high-resolution images with relatively small file sizes. Although it sacrifices some fine details, JPEG's efficient compression has made it a go-to format for web graphics and digital photography. "
            },
            {
                subTitle: "PNG",
                subTextShort: "picture.png",
                subTextLong: "PNG, or Portable Network Graphics, was developed as a replacement for the GIF format. Unlike GIF, PNG supports full-color images with high color depth and provides lossless compression. This means that PNG files can preserve all the original details and colors of an image while still achieving compression. PNG is widely used for images with transparency, such as logos, icons, and graphics, as it allows for clean edges and smooth transitions between opaque and transparent areas. "
            },
            {
                subTitle: "GIF",
                subTextShort: "meme.gif",
                subTextLong: "The Graphics Interchange Format (GIF) is a unique file format that gained popularity for its ability to support animated images. GIFs use a simple and efficient compression algorithm that allows for short and looping animations. While limited in color depth and resolution compared to other formats, GIFs became a beloved medium for sharing short and humorous animations on the internet. They are commonly used for expressing emotions, reactions, and conveying visual messages in a concise and engaging manner. "
            },
            {
                subTitle: "AVI",
                subTextShort: "video.avi",
                subTextLong: "Audio Video Interleave (AVI) is a multimedia container format that was developed by Microsoft. It was one of the first video formats to provide a synchronized audio and video playback. AVI files can contain both audio and video data, making them suitable for storing movies, TV shows, and other video content. While AVI is considered an older format, it is still widely compatible with various media players and editing software. "
            },
            {
                subTitle: "MP4",
                subTextShort: "film.mp4",
                subTextLong: "MP4, short for MPEG-4 Part 14, is a versatile video file format that was designed for efficient video streaming and sharing. It utilizes advanced video compression algorithms, such as the H.264 codec, to provide high-quality video with relatively small file sizes. MP4 files can contain both audio and video tracks, making them ideal for a wide range of applications, including online streaming, video sharing platforms, and portable media players. MP4 has become the most popular video format, offering a balance between file size and video quality. "
            },
            {
                subTitle: "MOV",
                subTextShort: "movie.mov",
                subTextLong: "MOV is a multimedia container format developed by Apple Inc. It was primarily designed for QuickTime, Apple's multimedia framework. MOV files can contain various types of media data, including video, audio, and even text tracks. This format has gained popularity among professionals in the film and video production industry due to its support for high-quality video and professional codecs like Apple ProRes. MOV files are widely compatible with both Mac and Windows operating systems and are commonly used for video editing and distribution. "
            },
            {
                subTitle: "WAV",
                subTextShort: "sound.wav",
                subTextLong: "WAV, short for Waveform Audio File Format, is an uncompressed audio format developed by Microsoft and IBM. It stores audio data in a raw and lossless manner, preserving the full quality and fidelity of the original recording. WAV files are commonly used in professional audio production and "
            },
            {
                subTitle: "FLV",
                subTextShort: "stream.flv",
                subTextLong: "FLV, or Flash Video, is a container file format developed by Adobe Systems. It was specifically designed for online video streaming and delivery. FLV files use a combination of audio and video codecs, such as H.264 for video and AAC for audio, to provide efficient compression and good quality playback. This format gained popularity with the rise of Flash-based video players and video-sharing websites. FLV files are known for their compatibility with Adobe Flash Player, making them suitable for online advertisements, web animations, and video platforms. "
            },
            {
                subTitle: "SVG",
                subTextShort: "icon.svg",
                subTextLong: "SVG, or Scalable Vector Graphics, is a file format used for two-dimensional vector graphics. Unlike raster-based formats like JPEG or PNG, SVG files store images as a set of mathematical equations and geometric shapes, allowing them to be scaled to any size without losing quality. SVG is widely used for web graphics, icons, logos, and illustrations, as it offers flexibility and sharpness across different devices and resolutions. Additionally, SVG files can be easily edited and animated using various design software and scripting languages, making them a popular choice for interactive web experiences. "
            },
        ],
    },
    {
        id: 2,
        image: IMG2,
        title: 'Media creation tools',
        author: 'Marvin',
        subjects: [
            {
                subTitle: "What is media software",
                subTextShort: "Software... To create media",
                subTextLong: "Long story short: Media Software is used to create digital media and these days quite anything online is _or can be considered as_ media. Ranging from simple texts in blog posts, explaining some sort of new way to cook, to terabytes of raw data sculpted into a movie Blockbuster - and of course everything in between, like streamed music or simple animations on websites.\n" +
                    "For such a vast variety of media to even exist, there has to be some sort of program, which can create them. One program alone however can't possibly create all forms of media on its own...\n" +
                    "...in this article we're going to start by taking a look at popular 'amateur'-programs to _create & edit_ images, sounds, videos. Then we'll switch over to professional applications of the same vendors/software and/or entirely different programs all together. "
            },
            {
                subTitle: "Popular apps for media-creation",
                subTextShort: "Different software from different vendors",
                subTextLong: "As mentioned above, there are lots of applications and programs for media creation. By now, each social media app on your phone probably has its own section to take & edit pictures or videos. Ignoring these however doesn't change a single thing about the fact that there are way too many apps to choose from.\n" +
                    "Listed & explained below are some of the most popular mobile & desktop apps, where one is able to create entire films or edit their pictures.\n\n" +
                    "Adobe is the most popular vendor of media-creation tools. Their arsenal of programs to creaate pretty much _every single fileformat there is_ is huge, but we won't need every single program listed in this article.\n" +
                    "Here are some of the more important programs:\n" +
                    "**Photoshop**, a program considered as the go-to for image editing. Photoshop has a huge amount of features for photographers to slightly enhance existing images by e.g. improving lighting or adjusting the colour. The features don't end there though, people all over the world use it to adjust pictures completely and e.g. make it seem a car is flying. \n" +
                    "**Premier Pro/Rush**. Whist _Premier Pro_ is the current Adobe-flagship of video editing all across YouTube and Hollywood, _Premier Rush_ is very popular among people who prefer to edit their videos on mobile devices. \n" +
                    "**After Effects** basically is the industry standard for VFX and CGI. VFX is the act of adding artifical computer-generated art/3-D graphics to _already existing_ videos, whilst CGI on the other hand is the creation of videos which purely consist of computer-generated 3-D graphics.\n" +
                    "**Davinci Resolve** is the way to go if one wants a whole arsenal of tools to create their own blockbuster movie: It has a built-in *\"speed-editor\"*, to quickly skip through a timeline and cut individual clips, a *\"normal editor\"*, in which the majority of the cutting and editing happens with basic transitions and titles, *\"fusion\"* - basically Adobe Aftereffects - where it's possible to create complex VFX and simple transitions and an entire \"*colour-grading section*\", which is pretty selfexplanatory.  \n" +
                    "And the best thing? It's completely free for personal use!"
            },
        ],
    }
]

export const copyrightContent = {
    id: 1,
    title: "Legal Notice",
    author: 'Marvin',
    subjects: [
        {
            subTitle: "Contact",
            subTextShort: "SueyWiky - GitHub Alley 420",
            subTextLong: "SueyWiky GitHub-Alley 420 GH-6969 Internet invalid@mail.com"
        },
        {
            subTitle: "Our purpose",
            subTextShort: "Improve general knowledge",
            subTextLong: "SueyWiky aims to improve the public's general knowledge about different forms of digital media, their details, when and where to use them and especially: How to create them.\n" +
                "Our primary objective is to explore the - now more than ever - ginourmous world of media file- types, addressing (almost) everything from texts and images to audio and vidoes. By documenting all kinds of relevant and/or interesting information one could possibly find on the internet on their own, we faciliate all of that endless searching.\n" +
                "Our Wiky serves as a hub for students, professors, normal people, strange people & more, who are passionate to learn more about the world of media, its diversity in different file types and how to integrate and create them in their own projects!\n" +
                "Join us - SueyWiky - on this exciting journey!"
        },
        {
            subTitle: "Privacy policy",
            subTextShort: "We collect no data!\nYour privacy is guaranteed",
            subTextLong: "SueyWiky does not collect and/or send any user data."
        }
    ]
}

export const disclaimerContent = {
    id: 1,
    title: "Disclaimer",
    author: 'Marvin',
    subjects: [
        {
            subTitle: "Our responsibility",
            subTextShort: "",
            subTextLong: "The information published on this website was carefully compiled and prepared. Nethertheless, SueyWiky does not take any responsibility for its accuracy or completeness."
        },
        {
            subTitle: "Third party services",
            subTextShort: "",
            subTextLong: "SueyWiky does not check any third-party database or website that are connected in any form to this website, e.g. links or images, and takes no responsibility for any texts, media services, advertisements or other content published on such sites. The same also applies in reverse."
        },
        {
            subTitle: "Contact us!",
            subTextShort: "",
            subTextLong: "If you were to discover any errors or false information on this wiki, feel free to inform us by e-mail to invalid@mail.com\n" +
                "This website - and all content, except our videos, coming along with it - generally are opensource; meaning free of any copyright."
        }
    ]
}

export const members = [
    {
        id: 1,
        image: MARVINPIC,
        name: "Marvin",
        desc: "Software engineer",
        text: "Hello there. Why not start by introducing myself. I'm Marvin, and I'm a software dev, like most - all* - people in our team. I primarily worked on this website and its articles, whilst also not forgetting about my video.\n" +
            "Andrei and I pretty much programmed this entire website. Additionally I'm primarily responsible for most of this website's articles/texts.",
        video: "https://youtu.be/4GrAp0sNumA",
        subjects: [
            {
                subTitle: "SueyWiky",
                subText: "Co-Creator of This Website",
            },
            {
                subTitle: "Coroutines",
                subText: "Made the Kotlin-Video",
            },
            {
                subTitle: "Articles",
                subText: "Wrote the most articles",
            },
        ],
    },
    {
        id: 2,
        image: ANDREIPIC,
        name: "Andrei",
        desc: "Software engineer",
        text: "Hey there, my name's Andrei. I'm a 21 year old software developer currently employed by Generali AG Switzerland. The website you are currently reading this on was mainly my responsibility, and therefore my main task.\n \n I of course also created an instructional video of my own, explaining the implementation of Google Maps in Android Appliactions using Kotlin.",
        video: "https://youtu.be/zfoBw7kAwHE",
        subjects: [
            {
                subTitle: "SueyWiky",
                subText: "Co-Creator of This Website",
            },
            {
                subTitle: "GMaps Android",
                subText: "Created video on this topic",
            },
            {
                subTitle: "Coder",
                subText: "In charge of programming.",
            },
        ],
    },
    {
        id: 3,
        image: GREGORPIC,
        name: "Gregor",
        desc: "Writer",
        text: "I am Gregor. I'm 18 and I work for SRF as a software developer. I took over the task of writing the articles together with Rinor. You will also find a video about a topic I was allowed to choose myself. I hope you like it.",
        video: "https://youtu.be/Eghj6T9AJUk",
        subjects: [
            {
                subTitle: "Articles",
                subText: "Wrote an article",
            },
            {
                subTitle: "Phishing Mails",
                subText: "Created video on this topic",
            },
        ],
    },
    {
        id: 4,
        image: RINORPIC,
        name: "Rinor",
        desc: "Writer",
        text: "My name is Rinor. I am 18 years old and I work for a company called Boreas. My task was to complete the articles together with gregor. Above my description you will find a video i made about the download of homebrew.",
        video: "https://www.youtube.com/watch?v=RO45hk_rMqw",
        subjects: [
            {
                subTitle: "Articles",
                subText: "Wrote an Article",
            },
            {
                subTitle: "Homebrew",
                subText: "Created video on this topic",
            }
        ],
    },
]
